import styled from 'styled-components'

const SelectFieldsWrapper = styled('div')`
  display: flex;
  margin: 0 -8px;
`

export default SelectFieldsWrapper
